<template>
    <div id="my-base-info">
      <div class="home-head">
        <head-common></head-common>
      </div>
      <base-info class="content">
        <h2>我的基本信息</h2>
      </base-info>
      <div class="home-footer">
        <footer-common></footer-common>
      </div>
    </div>
</template>

<script>
  import HeadCommon from './../HeadCommon.vue'
  import FooterCommon from "../FooterCommon";
  import BaseInfo from "./BaseInfo";

    export default {
        name: "MyBaseInfo",
      data: function () {
        return {
          responseData: {
            baseUserInfo: {
              data: {
                code: 200,
                data: {
                  username: "",
                  id: null
                }
              }
            },
          }
        }
      },
      methods: {
        clickMore: function () {
          /*todo 判断是否拿到页数*/
          this.getPage = false;
          //this.pageSize = 0;
        },
        clickMoreLeave: function () {
          this.getPage = true;
          console.log(2)
        }
      },
      components: {
        BaseInfo,
        FooterCommon,
        HeadCommon
      }
    }
</script>

<style scoped>
  div, img, ul, li, p, label, input {
    margin: 0 auto;
    padding: 0;
    border: 0;
  }
  #my-base-info {
    width: 1000px;
    border-style: dotted;
    border-color: aqua;
    background: rgba(204, 204, 204, 0.44);
  }

  #my-base-info .content {
    position: relative;
    display: inline-block;
    width: 75%;
    height: 100%;
    float: right;
    margin-top: 40px;
    padding: 24px;
    text-align: center;
  }
  #my-base-info .content .content-details {
    display: block;
    margin: 20px;
    border-style: solid;
    border-color: #189dce;
    border-width: 0 0 2px 0;
    line-height: 2.5em;
    font-size: 1.25em;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    animation: border-color-move 4s infinite linear alternate;
  }

  #my-base-info .home-footer {
    display: inline-block;
    width: 100%;
    height: 100px;
    border-style: solid;
    border-color: #797979;
    border-width: 2px 0;
  }
  /*规定动画*/
  @keyframes border-color-move {
    0% { border-color: #2fffbb;}
    25% { border-color: #ffdc51;}
    50% { border-color: #ff68e3;}
    75% { border-color: #2dccff;}
    100% { border-color: #34ff78;}
  }
</style>



// WEBPACK FOOTER //
// src/components/user/MyBaseInfo.vue